import { ButtonHTMLAttributes } from 'react';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

import { getButtonStyle } from 'commons';
import { LoaderWrapper } from 'components/loading';
import { BaseButtonProps } from 'types';

interface Props
  extends ButtonHTMLAttributes<HTMLButtonElement>, BaseButtonProps {}

export function Button({
  variant = 'primary',
  full = false,
  children,
  isLoading = false,
  type = 'button',
  disabled = false,
  hidden = false,
  className = '',
  ...rest
}: Props) {
  return (
    <button
      className={getButtonStyle({ variant, full, className, hidden })}
      type={type}
      disabled={disabled || isLoading}
      {...rest}
    >
      {!isLoading ? (
        children
      ) : (
        <LoaderWrapper>
          <AiOutlineLoading3Quarters size={20} />
        </LoaderWrapper>
      )}
    </button>
  );
}
